import { Button, Divider, Drawer, Typography } from "antd";
import React, {  useState, useEffect} from "react";
import Header from "../../Visits/components/Header";
import { useStateGlobalContext } from "../../../../../contexts/GlobalContext";
import ViewTemplate from "../../../Templates/components/ViewTemplate";
import PrintDrawer from "../../../../../components/GlobalComponents/PrintDrawer";
import { usePDF } from "react-to-pdf";



const {  Title, Paragraph } = Typography;
const  GeneralNotesPad = ({ visible, data, onClose }) => {
  const [loading, setLoading] = useState(true)
  const { officeSetting, patientBasicInfo ,providerDetails , getProviderDetails } = useStateGlobalContext()
  const full_name = `${patientBasicInfo?.first_name || ''} ${patientBasicInfo?.middle_name ? patientBasicInfo.middle_name + ' ' : ''}${patientBasicInfo?.last_name || ''}`.trim();


  const { toPDF, targetRef } = usePDF({
    filename: `${full_name}.pdf` || "Encounter.pdf",
    page: {
      format: "A4",
      orientation: "portrait",
      margin: 10,
    },
    scale: 0.95,
  });

  const downloadPDF = () => {
    const noPrintElements = document.querySelectorAll(".no-print");

    // Hide no-print elements before generating the PDF
    noPrintElements.forEach((el) => (el.style.display = "none"));

    // Generate the PDF
    toPDF().then(() => {
      // Show no-print elements after PDF is generated
      noPrintElements.forEach((el) => (el.style.display = ""));
    });
  };

  useEffect(() => {
    if (data?.provider_id) {
      getProviderDetails(data?.provider_id);
      setLoading(false)
    }
  }, [data?.provider_id]);

  return (
    <PrintDrawer
    title={full_name}
    visible={visible}
    onClose={onClose}
  >
      <div className="invoices-print">
        <div className="invoice-container">
        <Button onClick={downloadPDF} className="mb-2" type="primary"> 
            Download PDF
          </Button>
          <div className="invoice-content" ref={targetRef}>
            <h2 className="text-center mt-4 mb-4">Patient Notes: {data?.status === 'Cancelled' ? <span className="font-medium text-red-500">{data.status}</span>: data?.status}</h2>
            <Header
              officeInfo={officeSetting}
              patientInfo={patientBasicInfo}
              date={data?.signed_date}
              providerDetails={providerDetails}
            />
            <Divider />
            <Title className="text-center mt-4" level={5}>
              Patient Notes
            </Title>
            
            <Paragraph className="font-semibold">Reason: {data?.reason}</Paragraph>
            <ViewTemplate template={data?.notes}/>
          </div>
        </div>
      </div>
    </PrintDrawer>
  );
};

export default GeneralNotesPad
